import router from "@/router";

export class GoToRoute {
  redirectTo(page: string, id?: string | undefined, role?: string | undefined): void {
    if (id) {
      router.push({ name: page, params: { id: id, role: role } });
    } else {
      router.push({ name: page });
    } 
  }

  redirectToPage(page: string, routeParams?: any): void {
    if (routeParams) {
      router.push({ name: page, params: routeParams });
    } else {
      router.push({ name: page });
    }
  }
}
